import type {AxiosPromise} from 'axios';

import type {FileType, ActionType} from 'constants/flow/flowTypes';
import {PRODUCT} from 'constants/actions';

const initialState = {
    url: '',
    status: '',
    id: null,
};

/**
 * Save uploaded review file
 *
 * @param {FileType} state Current state
 * @param {ActionType<AxiosPromise>} action Received action
 * @returns {FileType | ?{}} Uploaded prescription file
 */
export default function uploadFile(
    state: FileType = initialState,
    action: ActionType<AxiosPromise>,
): FileType | ?{} {
    switch (action.type) {
        case `${PRODUCT.UPLOAD_REVIEW_FILE}_FULFILLED`:
            return {...action.payload.data, ...{status: 'fulfilled'}};
        case `${PRODUCT.UPLOAD_REVIEW_FILE}_PENDING`:
            return {status: 'pending'};
        case `${PRODUCT.UPLOAD_REVIEW_FILE}_REJECTED`:
            return {...action.payload.data, ...{status: 'rejected'}};
        default:
            return state;
    }
}
